// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Link from "../Link.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Search2 from "../common/Search2.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as AugmentName from "common/src/tft-static/AugmentName.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as InfoTooltip from "../components/InfoTooltip.bs.js";
import * as StatsConfig from "../stats/StatsConfig.bs.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as SearchField2 from "../components/SearchField2.bs.js";
import * as Belt_SetString from "rescript/lib/es6/belt_SetString.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import OpenInFull from "@mui/icons-material/OpenInFull";
import FormControlLabel from "@mui/material/FormControlLabel";
import PriorityHigh from "@mui/icons-material/PriorityHigh";

function renderStagePlace(v) {
  if (v.count < 10 || v.place > 7.5) {
    return T.emDash;
  } else if (v.count < 100) {
    return React.createElement("div", {
                className: "flex text-white2 items-center"
              }, React.createElement(PriorityHigh, {
                    fontSize: "inherit",
                    color: "inherit"
                  }), Global.toFixed(undefined, v.place));
  } else {
    return Global.toFixed(undefined, v.place);
  }
}

function tierOrder(tier) {
  switch (tier) {
    case "A" :
        return 5;
    case "B" :
        return 4;
    case "C" :
        return 3;
    case "D" :
        return 2;
    case "F" :
        return 1;
    case "S" :
        return 6;
    default:
      return 0;
  }
}

function renderStageTooltip(v, globalCount, stage) {
  if (v.count < 10 || v.place > 7.5) {
    return "Augment not offered at this stage";
  }
  if (v.count < 100) {
    var tmp;
    switch (stage) {
      case /* S21 */0 :
          tmp = "1st";
          break;
      case /* S32 */1 :
          tmp = "2nd";
          break;
      case /* S42 */2 :
          tmp = "3rd";
          break;
      
    }
    var tmp$1;
    switch (stage) {
      case /* S21 */0 :
          tmp$1 = "2-1";
          break;
      case /* S32 */1 :
          tmp$1 = "3-2";
          break;
      case /* S42 */2 :
          tmp$1 = "4-2";
          break;
      
    }
    return React.createElement("div", undefined, React.createElement("div", {
                    className: "flex items-center pb-1"
                  }, React.createElement(PriorityHigh, {
                        fontSize: "inherit"
                      }), "Very low sample size"), Global.toFixed(3, Global.f(v.count) / Global.f(globalCount) * 8) + " pickrate (" + T.humanReadableCount(v.count) + " games) and " + Global.toFixed(undefined, v.place) + " avg. place when picked as " + tmp + " augment (stage " + tmp$1 + ")");
  }
  var tmp$2;
  switch (stage) {
    case /* S21 */0 :
        tmp$2 = "1st";
        break;
    case /* S32 */1 :
        tmp$2 = "2nd";
        break;
    case /* S42 */2 :
        tmp$2 = "3rd";
        break;
    
  }
  var tmp$3;
  switch (stage) {
    case /* S21 */0 :
        tmp$3 = "2-1";
        break;
    case /* S32 */1 :
        tmp$3 = "3-2";
        break;
    case /* S42 */2 :
        tmp$3 = "4-2";
        break;
    
  }
  return Global.toFixed(3, Global.f(v.count) / Global.f(globalCount) * 8) + " pickrate (" + T.humanReadableCount(v.count) + " games) and " + Global.toFixed(undefined, v.place) + " avg. place when picked as " + tmp$2 + " augment (stage " + tmp$3 + ")";
}

function getGradeColor(grade) {
  switch (grade) {
    case "A" :
        return "text-epic-2";
    case "B" :
        return "text-rare-2";
    case "C" :
        return "text-uncommon-2";
    case "D" :
    case "F" :
        return "text-common";
    case "S" :
        return "text-legendary-2";
    default:
      return "";
  }
}

var cols = [
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Augment");
        }), undefined, (function (v, param, param$1) {
          var info = Data.augmentInfo(v.id, param$1.set);
          var match = Belt_Option.flatMap(info, (function (v) {
                  return v.hero;
                }));
          return React.createElement(React.Fragment, undefined, React.createElement(AugmentImage.make, {
                          augId: v.id,
                          size: 28
                        }), React.createElement("div", {
                          className: "pl-[6px] font-roboto font-normal truncate"
                        }, match !== undefined ? "[" + param$1.unitsT(match[0]) + "] " : null, React.createElement(AugmentName.make, {
                              id: v.id
                            })));
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return param$1.augmentsT(v.id);
        }), undefined, 180, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Games");
        }), undefined, (function (v, param, param$1) {
          return T.humanReadableCount(v.base.count);
        }), undefined, (function (v, param, param$1) {
          return Global.toFixed(3, Global.f(v.base.count) / Global.f(param[0]) * 8) + "/8 pick rate";
        }), undefined, (function (v, param, param$1) {
          return v.base.count;
        }), undefined, 84, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Place");
        }), undefined, (function (v, param, param$1) {
          return Global.toFixed(undefined, v.base.place);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.base.place;
        }), undefined, 72, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Top 4");
        }), undefined, (function (v, param, param$1) {
          return Global.formatPct3(v.base.top4);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.base.top4;
        }), undefined, 72, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Win");
        }), undefined, (function (v, param, param$1) {
          return Global.formatPct3(v.base.won);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.base.won;
        }), undefined, 70, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("At 2-1");
        }), undefined, (function (v, param, param$1) {
          return renderStagePlace(v.p1);
        }), undefined, (function (v, param, param$1) {
          return renderStageTooltip(v.p1, param[0], /* S21 */0);
        }), undefined, (function (v, param, param$1) {
          if (v.p1.count < 10) {
            return ;
          } else {
            return v.p1.place;
          }
        }), undefined, 76, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("At 3-2");
        }), undefined, (function (v, param, param$1) {
          return renderStagePlace(v.p2);
        }), undefined, (function (v, param, param$1) {
          return renderStageTooltip(v.p2, param[0], /* S32 */1);
        }), undefined, (function (v, param, param$1) {
          if (v.p2.count < 10) {
            return ;
          } else {
            return v.p2.place;
          }
        }), undefined, 76, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("At 4-2");
        }), undefined, (function (v, param, param$1) {
          return renderStagePlace(v.p3);
        }), undefined, (function (v, param, param$1) {
          return renderStageTooltip(v.p3, param[0], /* S42 */2);
        }), undefined, (function (v, param, param$1) {
          if (v.p3.count < 10) {
            return ;
          } else {
            return v.p3.place;
          }
        }), undefined, 76, undefined, undefined),
  StatsTable2.col(undefined, undefined, (function (param, param$1) {
          return param$1.t("Best With");
        }), "pl-6", (function (v, param, param$1) {
          return Belt_Array.mapWithIndex(Belt_Array.slice(v.topUsers, 0, 5), (function (idx, unit) {
                        return React.createElement(UnitTooltip.make, {
                                    unit: unit,
                                    children: React.createElement(UnitImage.make, {
                                          unitId: unit,
                                          size: 28
                                        }),
                                    key: unit
                                  });
                      }));
        }), "pl-6 justify-center gap-[5px]", undefined, undefined, undefined, false, 176, undefined, undefined),
  StatsTable2.col(undefined, undefined, (function (param, param$1) {
          return null;
        }), "h-1", (function (v, param, param$1) {
          return React.createElement(Link.make, {
                      className: "flex items-center",
                      route: {
                        TAG: /* Stats */0,
                        _0: {
                          TAG: /* Augment */7,
                          id: v.id,
                          aperture: param[1]
                        }
                      },
                      children: React.createElement(IconButton, {
                            onClick: (function (param) {
                                
                              }),
                            size: "small",
                            children: React.createElement(OpenInFull, {
                                  fontSize: "small"
                                })
                          })
                    });
        }), "pl-0 pr-0", undefined, undefined, undefined, undefined, 38, undefined, undefined)
];

function AugmentsPage$SinglesList(Props) {
  var augsData = Props.augsData;
  var globalCount = Props.globalCount;
  var showSilverAugs = Props.showSilverAugs;
  var showGoldAugs = Props.showGoldAugs;
  var showPrismAugs = Props.showPrismAugs;
  var search = Props.search;
  var set = TftSet.use(undefined);
  ScreenAtom.use(undefined);
  var aperture = ApertureCtx.useValue(undefined);
  var keyFn = React.useCallback((function (aug) {
          return aug.id;
        }), []);
  var showAllTiers = showSilverAugs && showGoldAugs && showPrismAugs || !showSilverAugs && !showGoldAugs && !showPrismAugs;
  var context = React.useMemo((function () {
          return [
                  globalCount,
                  aperture
                ];
        }), [
        globalCount,
        aperture
      ]);
  Translation.useT(/* Augments */4);
  Translation.useT(/* Units */1);
  var searchIds = React.useMemo((function () {
          if (search === "") {
            return ;
          } else {
            return Belt_SetString.fromArray(Search2.searchAugmentsArr(search, set));
          }
        }), [search]);
  var augsData$1 = React.useMemo((function () {
          return Belt_Array.keep(augsData, (function (d) {
                        return d.base.count >= 20;
                      }));
        }), [augsData]);
  var visibleFilter = React.useCallback((function (aug) {
          var augPass;
          if (showAllTiers) {
            augPass = true;
          } else {
            var info = Data.augmentInfoExn(aug.id, set);
            var match = info.rank;
            switch (match) {
              case 1 :
                  augPass = showSilverAugs;
                  break;
              case 2 :
                  augPass = showGoldAugs;
                  break;
              case 3 :
                  augPass = showPrismAugs;
                  break;
              default:
                augPass = false;
            }
          }
          if (augPass) {
            if (search === "") {
              return true;
            } else {
              return Belt_SetString.has(searchIds, aug.id);
            }
          } else {
            return false;
          }
        }), [
        search,
        showSilverAugs,
        showGoldAugs,
        showPrismAugs
      ]);
  return React.createElement("div", {
              className: "lg:w-[928px]"
            }, React.createElement(StatsTable2.make, {
                  cols: cols,
                  data: augsData$1,
                  context: context,
                  keyFn: keyFn,
                  stickyColCount: 1,
                  defaultSortIdx: 1,
                  visibleFilter: visibleFilter
                }));
}

var make = React.memo(AugmentsPage$SinglesList);

var SinglesList = {
  cols: cols,
  make: make
};

var cols$1 = [
  StatsTable2.col(undefined, undefined, (function (param, param$1) {
          return param$1.t("Augments");
        }), undefined, (function (stats, param, param$1) {
          return Belt_Array.map(stats.id, (function (id) {
                        return React.createElement("div", {
                                    className: "pr-1"
                                  }, React.createElement(AugmentImage.make, {
                                        augId: id,
                                        size: 27,
                                        key: id
                                      }));
                      }));
        }), undefined, undefined, undefined, undefined, undefined, 120, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Pick rate");
        }), undefined, (function (augStats, globalCount, param) {
          return Global.toFixed(4, Global.f(augStats.base.count) / Global.f(globalCount) * 8) + "/8";
        }), undefined, (function (v, param, param$1) {
          return T.humanReadableCount(v.base.count) + " games";
        }), undefined, (function (v, param, param$1) {
          return v.base.count;
        }), undefined, 95, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Games");
        }), undefined, (function (augStats, param, param$1) {
          return T.humanReadableCount(augStats.base.count);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.base.count;
        }), undefined, 80, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return "Place";
        }), undefined, (function (stats, param, param$1) {
          return Global.toFixed(undefined, stats.base.place);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.base.place;
        }), undefined, 70, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Top 4");
        }), undefined, (function (stats, param, param$1) {
          return Global.formatPct3(stats.base.top4);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.base.top4;
        }), undefined, 72, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Win");
        }), undefined, (function (stats, param, param$1) {
          return Global.formatPct3(stats.base.won);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.base.won;
        }), undefined, 66, undefined, undefined),
  StatsTable2.col(undefined, undefined, (function (param, param$1) {
          return param$1.t("Top Users");
        }), "pl-6", (function (stats, param, param$1) {
          return Belt_Array.mapWithIndex(Belt_Array.slice(stats.topUsers, 0, 5), (function (idx, unit) {
                        return React.createElement(UnitTooltip.make, {
                                    unit: unit,
                                    children: React.createElement(UnitImage.make, {
                                          unitId: unit,
                                          size: 28,
                                          key: unit
                                        })
                                  });
                      }));
        }), "pl-6 justify-center gap-1", undefined, undefined, undefined, undefined, 162, undefined, undefined)
];

function AugmentsPage$PairsList(Props) {
  var augsData = Props.augsData;
  var globalCount = Props.globalCount;
  var search = Props.search;
  var set = TftSet.use(undefined);
  var keyFn = React.useCallback((function (aug) {
          return aug.id.join("-");
        }), []);
  var t = Translation.useT(/* Augments */4);
  var searchStrings = React.useMemo((function () {
          return Belt_Array.concatMany(Belt_Array.map(Js_dict.entries(Data.augments(set)), (function (param) {
                            var id = param[0];
                            var name = param[1].name.toLowerCase();
                            var locName = t(id).toLowerCase();
                            if (name === locName) {
                              return [[
                                        id,
                                        name
                                      ]];
                            } else {
                              return [
                                      [
                                        id,
                                        name
                                      ],
                                      [
                                        id,
                                        locName
                                      ]
                                    ];
                            }
                          })));
        }), [t]);
  var searchIds = React.useMemo((function () {
          if (search === "") {
            return ;
          } else {
            return Belt_SetString.fromArray(Search2.searchAugmentsArr(search, set));
          }
        }), [
        searchStrings,
        search
      ]);
  var augsData$1 = React.useMemo((function () {
          if (search === "") {
            return augsData;
          } else {
            return Belt_Array.keep(augsData, (function (v) {
                          return v.id.some(function (id) {
                                      return Belt_SetString.has(searchIds, id);
                                    });
                        }));
          }
        }), [
        augsData,
        search
      ]);
  return React.createElement(StatsTable2.make, {
              cols: cols$1,
              data: augsData$1,
              context: globalCount,
              keyFn: keyFn,
              stickyColCount: 1
            });
}

var make$1 = React.memo(AugmentsPage$PairsList);

var PairsList = {
  cols: cols$1,
  make: make$1
};

function AugmentsPage$List(Props) {
  var augsData = Props.augsData;
  var globalCount = Props.globalCount;
  var t = Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return /* Singles */0;
      });
  var setTab = match[1];
  var tab = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setShowSilverAugs = match$1[1];
  var showSilverAugs = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setShowGoldAugs = match$2[1];
  var showGoldAugs = match$2[0];
  var match$3 = React.useState(function () {
        return false;
      });
  var setShowPrismAugs = match$3[1];
  var showPrismAugs = match$3[0];
  var match$4 = React.useState(function () {
        return "";
      });
  var search = match$4[0];
  var tmp;
  switch (tab) {
    case /* Singles */0 :
        tmp = React.createElement(make, {
              augsData: augsData.singles,
              globalCount: globalCount,
              showSilverAugs: showSilverAugs,
              showGoldAugs: showGoldAugs,
              showPrismAugs: showPrismAugs,
              search: search
            });
        break;
    case /* Pairs */1 :
        tmp = React.createElement(make$1, {
              augsData: augsData.pairs,
              globalCount: globalCount,
              search: search
            });
        break;
    case /* Triples */2 :
        tmp = React.createElement(make$1, {
              augsData: augsData.trios,
              globalCount: globalCount,
              search: search
            });
        break;
    
  }
  return React.createElement(ContentSection.make, {
              className: "py-3 px-0",
              children: null
            }, React.createElement("div", {
                  className: "flex flex-col md:flex-row md:justify-between"
                }, React.createElement("div", {
                      className: "pl-4 w-[240px] flex items-center gap-2"
                    }, React.createElement(SearchField2.make, {
                          search: search,
                          setSearch: match$4[1]
                        }), React.createElement(InfoTooltip.make, {
                          children: React.createElement("div", {
                                className: "leading-tight"
                              }, "Search for multiple augments at once by separating them with a comma. Example: celestial,thrill")
                        })), tab !== 0 ? React.createElement("div", undefined) : React.createElement("div", {
                        className: "flex pl-2 select-none"
                      }, React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: showSilverAugs,
                                  onChange: (function (e) {
                                      var checked = e.target.checked;
                                      return Curry._1(setShowSilverAugs, (function (param) {
                                                    return checked;
                                                  }));
                                    }),
                                  color: "primary",
                                  size: "small"
                                }),
                            label: t("Silver")
                          }), React.createElement("div", {
                            className: "px-2"
                          }, React.createElement(FormControlLabel, {
                                control: React.createElement(Checkbox, {
                                      checked: showGoldAugs,
                                      onChange: (function (e) {
                                          var checked = e.target.checked;
                                          return Curry._1(setShowGoldAugs, (function (param) {
                                                        return checked;
                                                      }));
                                        }),
                                      color: "primary",
                                      size: "small"
                                    }),
                                label: t("Gold")
                              })), React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: showPrismAugs,
                                  onChange: (function (e) {
                                      var checked = e.target.checked;
                                      return Curry._1(setShowPrismAugs, (function (param) {
                                                    return checked;
                                                  }));
                                    }),
                                  color: "primary",
                                  size: "small"
                                }),
                            label: t("Prismatic")
                          })), React.createElement(Tabs, {
                      children: null,
                      value: tab,
                      onChange: (function (param, t) {
                          return Curry._1(setTab, (function (param) {
                                        return t;
                                      }));
                        })
                    }, React.createElement(Tab, {
                          label: t("Single"),
                          value: /* Singles */0
                        }), React.createElement(Tab, {
                          label: t("Pairs"),
                          value: /* Pairs */1
                        }), React.createElement(Tab, {
                          label: t("Trios"),
                          value: /* Triples */2
                        }))), tmp);
}

var List = {
  make: AugmentsPage$List
};

function AugmentsPage(Props) {
  var globalCount = Props.globalCount;
  var augsData = Props.augsData;
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(StatsConfig.make, {}), React.createElement(StatsConfig.Context.make, {
                  children: React.createElement(AugmentsPage$List, {
                        augsData: augsData,
                        globalCount: globalCount
                      })
                }));
}

var make$2 = AugmentsPage;

export {
  renderStagePlace ,
  tierOrder ,
  renderStageTooltip ,
  getGradeColor ,
  SinglesList ,
  PairsList ,
  List ,
  make$2 as make,
  
}
/* cols Not a pure module */
